<template>
  <div>
    <div class="authority" v-if="status==true">
      <div class="content">
        <p>您没有权限查看页面</p>
        <p>如需开通请联系系统管理员</p>
      </div>
    </div>
    <div v-else class="rbox">
      <div>
        <div class="box">
          <p class="return" @click="back">返回首页</p>
          <span class="line">|</span>
          <p class="contract">系统设置</p>
          <span class="lines">></span>
          <p class="contract">组织管理</p>
        </div>
        <div class="p_btn">
          <div>
            <div class="mainTitle" @click="sort">组织管理</div>
          </div>

          <button class="btn subbtn" @click="add">新增组织</button>
        </div>
        <div>
          <SsgMessagebox
            :titles="tempShow?'新增组织': '编辑组织'"
            v-if="maskshow && masktype=='modifys'"
            height="300px"
            width="500px"
            @sub="addOrg"
            @shut="closewin"
          >
            <el-form
              :model="addForm"
              :rules="rules"
              label-width="100px"
              ref="addForm"
              class="demo-ruleForm"
            >
              <el-form-item label="组织名称" prop="orgName" haveto="true" style="margin-bottom:20px">
                <el-input v-model="addForm.orgName" maxlength="50" placeholder="请输入组织名称"></el-input>
              </el-form-item>
              <el-form-item label="上级组织" prop="positionId" haveto="true" style="margin-bottom:20px">
                <el-treeselect
                  v-model="addForm.positionId"
                  placeholder="请选择"
                  :data="positionList"
                  :props="props"
                  :search="false"
                ></el-treeselect>

                <!-- <el-select v-model="addForm.positionId" placeholder="请选择">
								<el-option :label="v.name" :value="v.id" v-for="(v,k) in positionList" :key="k"></el-option>
                </el-select>-->
              </el-form-item>
              <el-form-item v-if="tempShow==false" label="组织负责人" prop="userId">
                <button type="button" class="btn" @click="returactor" tag="button">选择组织负责人</button>
                <span
                  v-if="addForm.userNames"
                  style="  background-color:#888888;color: white;font-size: 12px;margin: 0px 3px ;padding: 4px;border-radius: 3px"
                >
                  {{addForm.userNames }}
                  <i
                    style="color: white;cursor: pointer"
                    class="el-icon-close"
                    @click="deletpepoe"
                  ></i>
                </span>
              </el-form-item>
            </el-form>
          </SsgMessagebox>

          <SsgMessagebox
            style="z-index: 10000"
            titles="选择组织负责人"
            v-if="maskshow && masktype=='aa' "
            height="655px"
            width="628px;"
            @sub="subSort"
            @shut="shutadd"
          >
            <el-table
              :data="lists"
              style="width: 100%"
              :header-cell-style="{background:'#f8fafb',color: '#303140'}"
            >
              <el-table-column label="姓名" prop="name" min-width="15%">
                <template slot-scope="scope">
                  <el-radio
                    v-model="checked"
                    style="margin-left: -10px;"
                    @change.native="getTemplateRow(scope.$index,scope.row)"
                    :label="scope.row.userId"
                  >{{scope.row.name}}</el-radio>
                </template>
              </el-table-column>
              <el-table-column label="手机号" prop="mobile" min-width="20%"></el-table-column>
            </el-table>
          </SsgMessagebox>
          <addorginstaff
            v-if="maskshow && masktype=='modify'"
            :type="1"
            @sub="submodify"
            :default="orginlist"
            :parentListDefault="selectIds"
          ></addorginstaff>
          <div class="table">
            <tree-table
              :data="data"
              :columns="columns"
              @deleOrgList="deleOrgList"
              @onmodifyCharge="onmodify"
              @handleCommand="handleCommand"
              :expandAll="true"
              v-if="tablevisible"
            />
            <el-table
              :data="data"
              style="width: 100%"
              :header-cell-style="{background:'#f8fafb',color: '#303140'}"
              v-if="!tablevisible"
            >
              <el-table-column prop="name" label="组织名称" min-width="120" align="left">
                <template slot-scope="scope">
                  <router-link
                    v-if="scope.row.parentId != 0"
                    :to="{path: '/organizationlist/organization/details', query: {id: scope.row.id}}"
                    tag="a"
                    class="link"
                    replace
                  >{{scope.row.name}}</router-link>
                  <span v-else>{{scope.row.name}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="num" label="在职人数" min-width="120" align="left">
                <template slot-scope="scope">{{scope.row.num}}人</template>
              </el-table-column>
              <el-table-column prop="chargeName" label="负责人" min-width="120" align="right">
                <template slot-scope="scope">
                  <span class="modify">
                    {{ scope.row.chargeName | null}}
                    <i @click="onmodify(scope.row)"></i>
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="操作" min-width="100" align="left">
                <template slot-scope="scope">
                  <div>
                    <el-dropdown @command="handleCommand" placement="bottom" size="small">
                      <span class="el-dropdown-link menu">
                        <span></span>
                        <i>操作</i>
                      </span>
                      <el-dropdown-menu slot="dropdown">
                        <div>
                          <el-dropdown-item :command="{flag: 1, row: scope.row}">新增组织</el-dropdown-item>
                        </div>
                        <div>
                          <el-dropdown-item :command="{flag: 2, row: scope.row}">编辑组织</el-dropdown-item>
                        </div>

                        <div>
                          <el-dropdown-item :command="{flag: 4, row: scope.row}">删除组织</el-dropdown-item>
                        </div>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import treeTable from "@/components/common/TreeTable";
import groupBtn from "@/components/common/groupBtnPermission";

export default {
  data() {
    return {
      status: false,
      props: {
        label: "name",
        value: "id",
        children: "childs",
      },
      tempShows: true,
      delet: false,
      subMessage: "",
      templateSelection: {},
      checked: "",
      currentSelectItem: {}, // 当前选中的值
      lists: [],
      rules: {
        orgName: [
          {
            required: true,
            message: "请输入组织名称",
            trigger: "blur",
          },
          {
            pattern: /^\S*$/,
            message: "不能输入空格",
          },
        ],
        positionId: [
          {
            required: true,
            message: "请选择上级组织",
            trigger: "change",
          },
        ],
      },
      addForm: {
        positionId: "",
        orgName: "",
        userId: "",
        userName: "",
        id: "",
        userNames: "",
      },
      addForms: {
        positionId: "",
        orgName: "",
        userId: "",
        userName: "",
        id: "",
        userNames: "",
      },
      positionList: [],
      tempShow: true,
      orgid: "",
      orginlist: [],
      selectIds: [],
      orgLists: [],
      columns: [
        {
          text: "组织名称",
          value: "name",
          width: 800,
          link: true,
        },
        {
          text: "在职人数",
          value: "num",
          // width: 200
        },
        {
          text: "负责人",
          value: "chargeName",
          // width: 200
        },
        {
          text: "操作",
          value: "edit",
          // width: 800,
          align: "right",
        },
      ],
      // morebtns: [{
      // 		name: '批量删除',
      // 		url: "relationship/addToBeEmployed"
      // 	},
      // 	{
      // 		name: '导出组织',
      // 		action: 'exportOrg',
      // 		btnPermissions: 'func:org:exp'
      // 	}
      // ],
      data: [],
      list: [],
      tablevisible: true,
      chargeNameList: [],
      addorgVisible: false,
      searchval: "",
      maskshow: false,
      masktype: "",
      mergeshow: false,
      modify: {
        id: "",
        userId: "",
      },
      chargerules: {
        userId: [
          {
            required: true,
            message: "请输入负责人姓名",
            trigger: "change",
          },
        ],
      },
      merge: {},
      pastDays: 0,
      chooseId: "",
      orgModel: {},
      stringify: "",
    };
  },
  mounted() {},
  created() {
    this.loadTableTree();
    this.filterOrg();
  },
  watch: {
    searchval(val) {
      if (val) {
        this.tablevisible = false;
        this.filterOrg(val);
      } else {
        this.tablevisible = true;
      }
    },
  },
  methods: {
    back() {
      this.$router.push({ path: "/main" });
    },
    deletpepoe() {
      this.addForm.userNames = "";
      this.addForm.userId = "";
      this.delet = true;
    },
    subSort() {
      if (this.templateSelection.orgId && this.templateSelection.userId) {
        return this.$axios
          .post(
            "org/editUserForOrg?id=" +
              this.templateSelection.orgId +
              "&userId=" +
              this.templateSelection.userId
          )
          .then((res) => {
            if (res.data.status == 1) {
              this.maskshow = false;
              this.masktype = "aa";
              if (this.tempShows == true) {
                this.loadTableTree();
              } else {
                this.maskshow = true;
                this.masktype = "modifys";
                this.addForm.userId = this.templateSelection.userId;
                this.addForm.userNames = this.templateSelection.name;
              }
            } else {
              this.$message.error(res.data.message);
            }
          })
          .catch((err) => {
            //处理错误
            console.error(err);
          });
      } else {
        this.maskshow = true;
        this.masktype = "modifys";
      }
    },
    shutadd() {
      this.maskshow = false;
      this.masktype = "aa";
      if (this.tempShows == true) {
      } else if (this.tempShows == false) {
        this.maskshow = true;
        this.masktype = "modifys";
      }
    },

    returactor() {
      this.maskshow = true;
      this.masktype = "aa";
      this.tempShows = false;
      this.lists = [];
      this.$axios.get("/org/getUserList?id=" + this.addForm.id).then((res) => {
        if (res.data.status == 1) {
          this.lists = res.data.data;
          if (this.addForm.userNames) {
            for (var i = 0; i < this.lists.length; i++) {
              if (this.addForm.userId === this.lists[i].userId) {
                this.checked = this.lists[i].userId;
              }
            }
          } else {
            this.checked = "";
          }
        }
      });
    },
    getTemplateRow(index, row) {
      this.templateSelection = row;
      console.log(this.templateSelection);
    },

    handleSelectionChange(row) {
      // 如果使用单选框,这里可以把当前选中的这一项先保存起来
      this.currentSelectItem = row;
    },
    sort() {
      this.maskshow = true;
      this.masktype = "addSort";
    },
    deleOrgList(name, id, orgId) {
      this.orginlist = [...id];
      this.selectIds = [...name];
      this.orgid = orgId;

      console.log(this.orginlist, this.selectIds);
      this.addOrgPeps();
    },
    filterOrg() {
      this.$axios.get("/org/getOrgList").then((res) => {
        if (res.data.status == 1) {
          this.positionList = res.data.data;
          console.log(this.positionList);
        }
      });
    },
    handleCommands(command) {
      if (command == "a") {
        this.exportOrg();
      } else if (command == "b") {
        this.$router.push("organization/delete");
      }
    },
    loadTableTree() {
      this.$axios.get("/org/getAllOrgTree").then((res) => {
        if (res.data.status == 1) {
          this.data = res.data.data;
        } else if (res.data.status == 2) {
          this.status = true;
        }
      });
    },
    handleCommand(command) {
      console.log(command);
      if (command.flag == 1) {
        this.filterOrg();

        this.tiels = "新增组织";
        this.addorgVisible = true;
        this.tempShow = true;

        this.maskshow = true;
        this.masktype = "modifys";
        // this.addForm.positionId= '';
        // this.addForm.orgName = '';
        this.addForm = {};
        this.addForm.positionId = command.row.id;
        console.log(this.addForm.positionId);
      }
      if (command.flag == 2) {
        this.tiels = "编辑组织";
        this.tempShow = false;
        this.maskshow = true;
        this.masktype = "modifys";
        var obj = {};
        this.addForm.orgName = command.row.name;
        this.addForm.positionId = command.row.parentId;
        this.addForm.userNames = command.row.userName;
        this.addForm.userId = command.row.userId;
        this.addForm.id = command.row.id;
        this.$axios
          .get("/org/getOrgList?type=" + 1 + "&orgId=" + command.row.id)
          .then((res) => {
            if (res.data.status == 1) {
              this.positionList = res.data.data;

              console.log(this.positionList);
            }
          });
      }
      if (command.flag == 3) {
        this.mergeshow = true;
        let params = {
          id: command.row.id,
          pNumber: command.row.pNumber,
          orgName: command.row.label,
        };
        this.merge = params;
      }
      if (command.flag == 4) {
        this.$confirm(
          "您确定要删除名称为【" + command.row.name + "】的组织吗?",
          "删除组织",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        ).then(() => {
          this.$axios
            .post("/org/deleteOrg?id=" + command.row.id)
            .then((res) => {
              if (res.data.status == 1) {
                this.$message.success(res.data.message);
                this.loadTableTree();
              } else {
                this.$message.error(res.data.message);
              }
            });
        });
      }
    },

    addorganization() {
      this.tiels = "新增组织";
      this.addorgVisible = true;
      this.orgModel = {};
      this.chooseId = this.data[0].id;
    },

    //列表添加负责人
    onmodify(val) {
      console.log(val);
      this.tempShows = true;
      this.$axios.get("/org/getUserList?id=" + val.id).then((res) => {
        if (res.data.status == 1) {
          this.lists = res.data.data;
          if (!this.addForm.userName) {
            this.checked = "";
          }
        }
      });
      this.orginlist = [
        ...(val.userId != null ? val.userId.toString().split(",") : []),
      ];
      this.selectIds = [
        ...(val.chargeName != null ? val.chargeName.toString().split(",") : []),
      ];
      // this.chargeNameList = [{
      //   chargeName: val.chargeName,
      //   userid: val.userId
      // }];
      this.maskshow = true;
      this.masktype = "aa";
      this.modify.userId = val.userId;
      this.modify.id = val.id;
      this.orgid = val.id;
      // this.addOrgPeps()
    },
    submodify(ids, name) {
      this.orginlist = [...ids];
      this.selectIds = [...name];
      this.addOrgPeps();
    },
    add() {
      this.maskshow = true;
      this.masktype = "modifys";
      this.tempShow = true;
      this.addForm.orgName = "";
      this.addForm.positionId = "";
      this.addForm.userName = "";
      this.addForm.userId = "";
    },
    closewin() {
      this.maskshow = false;
      this.masktype = "modifys";
    },

    // 添加组织
    addOrg() {
      this.$refs.addForm.validate((status) => {
        if (status == true) {
          if (this.tempShow == true) {
            return this.$axios
              .post(
                "org/addOrg?name=" +
                  this.addForm.orgName +
                  "&parentId=" +
                  this.addForm.positionId
              )
              .then((res) => {
                if (res.data.status == 1) {
                  this.$message.success(res.data.message);
                  this.maskshow = false;
                  this.loadTableTree();
                  this.filterOrg();
                } else {
                  this.$message.error(res.data.message);
                }
              })
              .catch((err) => {
                //处理错误
                console.error(err);
              });
          } else {
            return this.$axios
              .post(
                "org/updateOrg?name=" +
                  this.addForm.orgName +
                  "&parentId=" +
                  this.addForm.positionId +
                  "&userId=" +
                  this.addForm.userId +
                  "&id=" +
                  this.addForm.id
              )
              .then((res) => {
                if (res.data.status == 1) {
                  this.$message.success(res.data.message);
                  this.maskshow = false;
                  if (this.delet) {
                    this.delet = false;
                    this.$axios
                      .post(
                        "org/editUserForOrg?id=" +
                          this.addForm.id +
                          "&userId=" +
                          ""
                      )
                      .then((res) => {
                        if (res.data.status == 1) {
                          this.addForm.userName = "";
                          this.addForm.userId = "";
                          this.loadTableTree();
                          this.filterOrg();
                        } else {
                          this.$message.error(res.data.message);
                        }
                      })
                      .catch((err) => {
                        //处理错误
                        console.error(err);
                      });
                  }

                  this.loadTableTree();
                } else {
                  this.maskshow = false;
                  this.$message.error(res.data.message);
                }
              })
              .catch((err) => {
                //处理错误
                this.maskshow = false;
                console.error(err);
              });
          }
        }
      });
    },

    addOrgPeps() {
      var param =
        "orgId=" +
        this.orgid +
        "&userId=" +
        this.orginlist.toString() +
        "&userName=" +
        this.selectIds.toString();
      return this.$axios
        .post(
          "org/editUserForOrg?id=" +
            this.orgid +
            "&userId=" +
            this.orginlist.toString()
        )
        .then((res) => {
          if (res.data.status == 1) {
            this.loadTableTree();
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          //处理错误
          console.error(err);
        });
    },
    remoteMethod(query) {
      this.$axios
        .get("/employee/findOrgChargeNameInEmployee?name=" + query)
        .then((res) => {
          if (res.data.status == 1) {
            this.chargeNameList = res.data.data;
          }
        });
    },
    callback(data) {
      this.tablevisible = true;
      this.loadTableTree();
    },
    exportOrg() {
      const loading = this.$loading({
        text: "正在下载，请稍后",
      });
      this.$axios
        .get("/batchorg/export", {
          responseType: "blob",
        })
        .then((res) => {
          let blob = res.data;
          let reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onload = (e) => {
            let a = document.createElement("a");
            let headers = res.headers;
            let fileName = headers["content-disposition"];
            a.download = this.getCharFromUtf8(fileName);
            a.href = e.target.result;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            loading.close();
          };
        });
    },
  },
  components: {
    treeTable,
    groupBtn,
  },
};
</script>

<style src="../../../assets/css/common/nav.less" scoped lang="less"></style>
<style src="../../../assets/css/common/operating.less" scoped lang="less"></style>
<style src="../../../assets/css/common/table.less" scoped lang="less"></style>
<style scoped lang="less">
.tab_nav {
  height: 72px;
}

.form {
  width: 100%;
  margin: 30px 0;
}

.el-select {
  width: 100%;
}

.modify {
  display: flex;
  align-items: center;
}

.modify i {
  width: 18px;
  height: 18px;
  display: block;
  background-image: url(../../../assets/img/organization03.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: 18px;
  margin-left: 5px;
  cursor: pointer;
}

/*.modify i:hover {*/
/*background-image: url(../../../assets/img/rename_b.png);*/
/*}*/

.link {
  color: #6669e3;
  cursor: pointer;
}
.box {
  display: flex;
  margin-top: 20px;

  .return {
    font-size: 12px;
    font-weight: 400;
    color: rgba(102, 105, 227, 1);
    margin-right: 20px;
    cursor: pointer;
  }

  .line {
    margin-right: 20px;
    color: #606266;
  }

  .lines {
    margin-right: 20px;
    color: #606266;
    font-weight: bold;
  }

  .contract {
    margin-right: 20px;

    font-size: 12px;
    font-weight: 400;
    color: rgba(138, 138, 154, 1);
  }
}
.mainTitle {
  font-size: 24px;
  font-weight: bold;
  color: rgba(48, 49, 64, 1);
  margin: 33px 0 14px 0;
}
.authority {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  margin:100px auto;

  .content {
    text-align: center;
    margin: 50px auto;
    font-size: 24px;
    font-weight: bold;
    color: #303140;
  }
}
</style>
